import { HOST } from "@components/Constants";
import { type OrganizationPublicKeyAudience } from "@api/types";

import { AUDIENCE_BACKSTAGE } from "./audiences";

const HTTPS_PREFIX = "https://";
const SPEC_DIRECTORY = "/static/specs";

const SPEC_INVESTOR = "investor.swagger.json";
const SPEC_BACKSTAGE = "backstage.swagger.json";

const TITLE_INVESTOR = "Investor Portal API";
const TITLE_BACKSTAGE = "Back Office API";

export type Specification = {
  url: string;
  host: string;
  title: string;
  fileName: string;
  path: string;
};

type Props = {
  domain?: string;
  audience: OrganizationPublicKeyAudience;
};

// NOTE: the client calls the API on the domain of the organization. An
//       organization with no domain of its own uses the host of this app.
export const getClientHost = (domain?: string): string => {
  const hasDomain = !!domain;

  if (!hasDomain) {
    return HOST;
  }

  const host = `${HTTPS_PREFIX}${domain}`;

  return host;
};

const getSpecification = ({
  domain,
  audience,
}: Props): Specification => {
  const isBackstageAudience = audience === AUDIENCE_BACKSTAGE;

  const fileName = isBackstageAudience
    ? SPEC_BACKSTAGE
    : SPEC_INVESTOR;

  const title = isBackstageAudience
    ? TITLE_BACKSTAGE
    : TITLE_INVESTOR;

  const host = getClientHost(domain);
  const specificationPath = `${SPEC_DIRECTORY}/${fileName}`;
  const url = `${host}${specificationPath}`;

  const specification = {
    url,
    host,
    title,
    fileName,
    path: specificationPath,
  };

  return specification;
};

export default getSpecification;
